import { render, staticRenderFns } from "./trading-summary.vue?vue&type=template&id=43e7c79c"
import script from "./trading-summary.vue?vue&type=script&lang=js"
export * from "./trading-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./trading-summary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChartComponent: require('/vercel/path0/components/ui/ChartComponent.vue').default,FootNote: require('/vercel/path0/components/FootNote.vue').default})
